import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './page/login';
import TokenLogin from './page/TokenLogin';
import HealthBook from './page/healthbook';
import Template from './page/template';
// import Vaccine from './page/vaccination';
import HealthRecordsHistory from './page/HealthRecordsHistory';
import PublicHealthbook from './page/PublicHealthbook';

// Global styles
const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Prompt', sans-serif;
  }
  
  html, body {
    font-family: 'Prompt', sans-serif;
    margin: 0;
    padding: 0;
    height: 100%;
    min-width: 1200px;
  }
  
  #root {
    height: 100vh;
    min-width: 1200px;
  }
`;

const AppContainer = styled.div`
  font-family: 'Prompt', sans-serif;
  min-height: 100vh;
`;

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <GlobalStyle />
        <AppContainer>
          <Routes>
            {/* Login Routes */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/token-login" element={<TokenLogin />} />

            {/* Public Route - ไม่ต้อง login (สำหรับแชร์ผู้ป่วย) */}
            <Route path="/public/healthbook" element={<PublicHealthbook />} />

            {/* Protected Routes - ต้อง login ก่อนถึงเข้าได้ */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HealthBook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/healthbook"
              element={
                <ProtectedRoute>
                  <HealthBook />
                </ProtectedRoute>
              }
            />
            <Route
              path="/template"
              element={
                <ProtectedRoute>
                  <Template />
                </ProtectedRoute>
              }
            />
            {/* <Route path="/vaccination" element={<Vaccine />} /> */}
            <Route
              path="/health-records-history"
              element={
                <ProtectedRoute>
                  <HealthRecordsHistory />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AppContainer>
      </AuthProvider>
    </Router>
  );
};

export default App;